export const config = {
  intro: {
    dropShadow: true,
    dropShadowAlpha: 0.7,
    dropShadowBlur: 4,
    dropShadowDistance: 2,
    fill: [
      '#ffffff',
      '#9a0e0e',
    ],
    strokeThickness: 2,
    fontFamily: 'Druk Text Cy',
    fontWeight: 'bolder',
  },
}
